import { createSelector } from "reselect"
import { get, chain, map } from "lodash"
import moment from "moment"
import { getMustAggregateFactors } from "modules/portfolio-root/selectors/portfolios"
import { getModelFactorsClassification } from "selectors/modelMetadata"
import { getSelectedMetric } from "./metrics"
import { mapAggregatedFactors } from "../helpers"

const getRawData0 = state => get(state, "global.data.comparePerformancePositionSet0.data.model.simulation.performance")
const getRawData1 = state => get(state, "global.data.comparePerformancePositionSet1.data.model.simulation.performance")
const getRawData2 = state => get(state, "global.data.comparePerformancePositionSet2.data.model.simulation.performance")
const getRawData3 = state => get(state, "global.data.comparePerformancePositionSet3.data.model.simulation.performance")
const getRawData4 = state => get(state, "global.data.comparePerformancePositionSet4.data.model.simulation.performance")

export const getData0 = createSelector([getRawData0, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)
export const getData1 = createSelector([getRawData1, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)
export const getData2 = createSelector([getRawData2, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)
export const getData3 = createSelector([getRawData3, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)
export const getData4 = createSelector([getRawData4, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)

function getDataMap({ value: selector }, data) {
  if (!data) {
    return null
  }

  return chain(data)
    .keyBy("date")
    .mapValues(selector)
    .value()
}

export const getDataMap1 = createSelector([getSelectedMetric, getData1], getDataMap)
export const getDataMap2 = createSelector([getSelectedMetric, getData2], getDataMap)
export const getDataMap3 = createSelector([getSelectedMetric, getData3], getDataMap)
export const getDataMap4 = createSelector([getSelectedMetric, getData4], getDataMap)

export const getData = createSelector(
  [getSelectedMetric, getData0, getDataMap1, getDataMap2, getDataMap3, getDataMap4],
  ({ value: selector }, data, dataMap1, dataMap2, dataMap3, dataMap4) => {
    return map(data, item => ({
      date: moment(item.date),
      0: selector(item),
      1: dataMap1 ? get(dataMap1, item.date, 0) : undefined,
      2: dataMap2 ? get(dataMap2, item.date, 0) : undefined,
      3: dataMap3 ? get(dataMap3, item.date, 0) : undefined,
      4: dataMap4 ? get(dataMap4, item.date, 0) : undefined,
    }))
  },
)
